<template>
  <!-- Content -->
  <section id="content" class="content terms-cont">
    <!-- Content Header -->
    <!--    <div class="content-header sub-visual">
          <div class="sub-visual-bg"></div>
          <div class="in-sec">
            &lt;!&ndash; 고도화 Ver1 : br추가 &ndash;&gt;
            <div class="tit-wrap centered-c">
              <h2 class="tit-h2" v-html="$t('sdp.menu.device.terms_condition')"></h2>
            </div>
          </div>
        </div>-->
    <!-- //Content Header -->

    <!-- Content Body -->
    <div class="content-body">
      <!-- 탭전체영역 -->
      <!-- 약관 개편 : 2026.04.15 -->

      <div class="tab-type4-wrap in-sec">
        <nav class="tab-nav tab-change tab-type4 m-aco">
          <!-- 아코디언 헤더 (PC: 단순 제목 / Mobile: 버튼 역할) -->
          <h2 class="terms-tit" v-html="$t('sdp.menu.device.terms_condition.new')"></h2>
          <ul role="tablist">
            <template v-for="(title, index) in termsTitle">
              <li role="presentation" :class="{'is-active' : isActive((index+1))}">
                <a v-if="index == 0" @click="getDeviceTerms(title.termsMgtTpCode,'1')" href="#tabContentTerms1" role="tab" id="tabNavTerms1" aria-controls="tabContentTerms1" aria-selected="true">
                  <span class="tit" v-html="title.termsTpName"></span>
                </a>
                <a v-else @click="getDeviceTerms(title.termsMgtTpCode,(index+1))" :href="'#tabContentTerms'+(index+1)" role="tab" :id="'tabNavTerms'+(index+1)" :aria-controls="'tabContentTerms'+(index+1)" aria-selected="false">
                  <span class="tit" v-html="title.termsTpName"></span>
                </a>
              </li>
            </template>
          </ul>
        </nav>

        <div class="section-body" v-if="loadingYn == 'Y'">
          <div class="loading-wrap">
            <div class="loading"><img src="/img/cmn/loading.png" :alt="$t('gwa.alt.common.wa_etc_1')"></div>
          </div>
        </div>
        <!-- 탭컨텐츠 -->
        <div class="tab-body" v-else>
          <!-- 공통 고지문 -->
          <div class="terms-info">
            <p v-html="$t('sdp.menu.device.terms_condition.message')"></p>
          </div>
          <!-- //공통 고지문-->
          <!-- 아카이빙 -->
          <template v-if="historyTerms.length > 0">
            <div class="stTermsSelect flex">
              Archived
              <span class="form-select form-size-md">
                <template v-if="cntryCode == 'KR'">
                  <select v-model="selectedTerms" name="sTypes" title="">
                    <template v-for="(terms, index) in historyTerms">
                      <option :value="index">{{ terms.applyYear }}년 {{ terms.applyMonth }}월 {{ terms.applyDay }}일</option>
                    </template>
                  </select>
                </template>
                <template v-else>
                  <select v-model="selectedTerms" name="sTypes" title="">
                    <template v-for="(terms, index) in historyTerms">
                      <option :value="index">{{ terms.applyDate }}</option>
                    </template>
                  </select>
                </template>
              </span>
            </div>
          </template>
          <!-- // 아카이빙 -->
          <!-- 약관 내용 -->
          <template v-for="(title, index) in termsTitle">
            <div :id="'tabContentTerms'+(index+1)" class="tab-content" :class="{'is-active' : isActive((index+1))}" role="tabpanel" :aria-labelledby="'tabNavTerms'+(index+1)">
              <h3 v-if="index > 0" class="blind blind-labelledby dv-pc-only" :data-labelledby="'tabNavTerms'+(index+1)"></h3>
              <div class="terms-sec-tit" tabindex="-1" v-html="title.termsTpName"></div>
              <template v-if="historyTerms.length > 0">
                <div :id="'termsSec'+(index+1)" class="terms-sec-wrap">
                  <template v-for="(terms, index) in historyTerms">
                    <div v-if="selectedTerms == index" class="terms-sec" v-html="terms.termsCntt"></div>
                  </template>
                </div>
              </template>
              <template v-else>
                <div :id="'termsSec'+(index+1)" class="terms-sec-wrap">
                  <div class="terms-sec" v-html="deviceTerms.termsCntt"></div>
                </div>
              </template>
            </div>
          </template>
          <!-- //약관 내용 -->
        </div>
        <!-- //탭컨텐트 -->
      </div>
      <!-- //탭전체영역 -->

      <!-- 팝업_FR국가 법적고지(NOTES JURIDIQUES) PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중 -->
      <div v-show="cntryCode == 'FR'">
        <TermsPop></TermsPop>
      </div>
      <!-- //팝업_FR국가 법적고지(NOTES JURIDIQUES) PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중 -->

    </div>
    <!-- //Content Body -->
  </section>
  <!-- //Content -->
</template>

<script>
import qs from "qs";
import TermsPop from '@/components/terms/TermsPop';

export default {
  name: "Terms",
  components: {
    TermsPop //PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중
  },
  data() {
    return {
      termsTitle: [],
      deviceTerms: {},
      historyTerms: [], // 2024.04.11 송준형 : REQSDP-4428 - [pc mall] 약관아카이빙 적용
      selectedTerms: "", // 2024.04.16 송준형 : REQSDP-4428 - [pc mall] 약관아카이빙 적용
      gdprFlag: "",
      plfmCode: "W26O", // 2025.11.18 송준형 : REQSDP-9060 - [신규]pc website W26O 중국 약관 구조 변경
      plfmCodeList: "W24O,W25O,W26O", // 2026.01.05 송준형 : REQSDP-9433 - [pcmall] 한국 개인정보처리방침 페이지 이력관리 요청
      termsCode: "", // 2024.04.17 송준형 : REQSDP-4428 - [pc mall] 약관아카이빙 적용
      loadingYn: "Y",
      activeId: "", // 2024.06.24 송준형 : REQSDP-5357 - PC Mall 웹접근성 심사결과대응 2차
      cntryCode: _domainCntryCode // 2025.11.11 송준형 : REQSDP-8990 - [PC Mall] PC website W26O 약관 미국 아카이빙 수정 반영
    }
  },
  methods: {
    track () {
      console.log('@@@@ track:', this.$router.currentRoute.path);
      this.$ga.page(this.$router.currentRoute.path)
    },
    getDeviceTerms(type,id) {
      const vm = this;
      vm.loadingYn = "Y";
      ui.loading.open();

      var termsMgtTpCode = type;
      const params = {
        termsMgtTpCode : termsMgtTpCode,
        plfmCode : vm.plfmCode,
        plfmCodeList : vm.plfmCodeList, // 2024.04.09 송준형 : REQSDP-4428 - [pc mall] 약관아카이빙 적용
        netcastYn : "N"
      };

      this.$axios.post("/api/terms/retrieveDeviceTerms.ajax",
          qs.stringify(params)).then((result) => {
        ui.loading.close();
        vm.termsTitle = result.data.termsTitle;
        vm.deviceTerms = result.data.deviceTerms;
        vm.historyTerms = result.data.historyTerms; // 2024.04.11 송준형 : REQSDP-4428 - [pc mall] 약관아카이빙 적용
        vm.gdprFlag = result.data.gdprFlag;
        vm.loadingYn = "N";

        vm.$nextTick(function() {
          vm.selectedTerms = 0; // 2025.02.18 송준형 : REQSDP-6685 - [pc mall] 약관 아카이빙 적용 및 최신 약관 연동 업데이트 (24년 ->25년)
          vm.termsCode = termsMgtTpCode; // 2024.04.17 송준형 : REQSDP-4428 - [pc mall] 약관아카이빙 적용
          vm.activeId = id; // 2024.06.24 송준형 : REQSDP-5357 - PC Mall 웹접근성 심사결과대응 2차

          if(document.querySelector('.m-aco').classList.contains('is-open')) {
            ui.termsAcod.close();
          }

          $(window).scrollTop(0);
          loadLabelledby();
          if ($('.terms-sec span').length){ $('.terms-sec span').removeAttr('style'); }
        });
      }).catch((err) => {
        ui.loading.close();
        vm.loadingYn = "N";
        alert("error : " + err);
      });
    },
    isActive(id) {
      if(this.activeId == id) {
        return true;
      } else {
        return false;
      }
    }
  },
  computed: {

  },
  mounted() {
    const vm = this;
    vm.getDeviceTerms("S_LGN","1");
    vm.$nextTick(function() {
      ui.termsAcod.init();
    });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
